export default {
  name: 'Cone',
  icon: 'mdi-wrench',
  label: 'Cone',
  showInMenu() {
    return false;
  },
};
